import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="contact-info">
          <p className="with-bg copy" onClick={() => navigator.clipboard.writeText("+212 669 035 139")}>
            +212 669 035 139
          </p>

          <p className="with-bg copy" onClick={() => navigator.clipboard.writeText("+212 525 205 900")}>
            +212 525 205 900
          </p>

          <p className="with-bg email" onClick={() => window.location.href = "mailto:contact@jway.ma"}>
            contact@jway.ma
          </p>
        </div>
        <div className="contact-info">
          <a href="https://jway.ma/" class="explore-btn">Notre Site Web</a>
        </div>
        <span className="separator"> | </span>
        <p className="contact-info">
          <p
            className="faq-link"
            onClick={() => navigate("/faq")}
            title="Voir la FAQ"
          >
            FAQ 
          </p>
          <p
            className="faq-link"
            onClick={() => navigate("/mentionslegales")}
            title="Voir la FAQ"
          >
            MENTIONS LÉGALES  
          </p>
          <p
            className="faq-link"
            onClick={() => navigate("/conditionsgeneral")}
            title="Voir la FAQ"
          > 
            CONDITIONS GÉNÉRALES
          </p>
          
        </p>
      </div>
    </footer>
  );
}

export default Footer;
